export default (modal) => {
  'ngInject';

  return () => {
    return modal.open({
      template: '<sa-join-form done="close()"></sa-join-form>',
    }).result;
  };
};



// WEBPACK FOOTER //
// ./app/src/modules/join/join_form.service.js